import { useContext } from 'react';
import { MetaContext } from 'src/contexts/meta/metaContext';

export const useMeta = () => useContext(MetaContext);
